import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { IdScanlocalizationStrings, IdScanSupportedLanguage } from './index';
import { useTranslationConfig } from '../pageLayout/localization/useTranslationConfig';

interface IdScanLocalizationContextType {
  localizationStrings: Record<string, string>;
}

const IdScanLocalizationContext = createContext<
  IdScanLocalizationContextType | undefined
>(undefined);

export const IdScanLocalizationProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { selectedLanguage } = useTranslationConfig();
  const getValidIdScanLanguage = (language: string) => {
    if (Object.keys(IdScanlocalizationStrings).includes(language)) {
      return language as IdScanSupportedLanguage;
    }
    return 'de';
  };
  const [idScanLanguage, setIdScanLanguage] = useState<IdScanSupportedLanguage>(
    getValidIdScanLanguage(selectedLanguage.toLowerCase())
  );

  const localizationStrings = useMemo(() => {
    return IdScanlocalizationStrings[idScanLanguage];
  }, [idScanLanguage]);

  useEffect(() => {
    setIdScanLanguage(
      getValidIdScanLanguage(
        selectedLanguage.toLowerCase()
      ) as IdScanSupportedLanguage
    );
  }, [selectedLanguage]);

  return (
    <IdScanLocalizationContext.Provider value={{ localizationStrings }}>
      {children}
    </IdScanLocalizationContext.Provider>
  );
};

export const useIdScanLocalization = () => {
  const context = useContext(IdScanLocalizationContext);
  if (context === undefined) {
    throw new Error(
      'useIdScanLocalization must be used within a IdScanLocalizationProvider'
    );
  }
  return context;
};
